"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _waitToDoRequest = require("@/api/common/waitToDoRequest");
var _sysRoleAcl = require("@/api/system/sysRoleAcl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Profile',
  components: {},
  data: function data() {
    return {
      basicMenu: [{
        id: 1,
        icon: 'iconxiugai',
        title: '修改密码',
        type: 'resetPassword'
      }, {
        id: 5,
        icon: 'iconrizhi1',
        title: '操作日志',
        url: '/userCenter/optLog'
      },
      // {
      //   id: 6,
      //   icon: 'iconyuyan',
      //   title: '语言设置'
      // },
      {
        id: 7,
        icon: 'iconfankui2',
        title: '建议反馈'
      }]
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['userInfo', 'language', 'deploy'])),
  created: function created() {},
  methods: {
    /* 点击 */itemClick: function itemClick(item) {
      if (item.url) {
        this.$router.push(item.url);
      }
      if (item.type === 'resetPassword') {
        this.$store.dispatch('desktopConfig/showResetPassword', true);
      }
    }
  }
};